module.exports = __webpack_public_path__ + "img/8.de6d2a2e.svg";